import React from "react";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteStatics },
  },
} = getConfig();

// TODO replace with site wide fallback
const DEFAULT_FALLBACK = `${websiteStatics}/images/benefits-placeholder.svg`;

// onError is not fired sometimes because of next.js, so this may fail sometimes

const ImageWithFallback = (props) => {
  const fallback = props.fallback || DEFAULT_FALLBACK;
  const src = props.src || fallback;

  return (
    <img {...props} src={src} onError={(e) => (e.target.src = fallback)} />
  );
};

export default ImageWithFallback;
